module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "page-loading loader-inner ball-pulse"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "! isLoading"
    }],
    staticClass: "thread"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentPage == 1),
      expression: "currentPage == 1"
    }],
    staticClass: "thread-header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-7"
  }, [_c('small', [_vm._v(_vm._s(_vm.time))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.jumpToBoard(_vm.board.name)
      }
    }
  }, [_c('small', [_vm._v(_vm._s(_vm.board.description + '/' + _vm.board.name))])])])]), _vm._v(" "), _c('hr')]), _vm._v(" "), (_vm.mainPost && _vm.currentPage == 1) ? _c('div', {
    staticClass: "article"
  }, [_c('div', {
    staticClass: "poster media"
  }, [_c('figure', {
    staticClass: "media-left"
  }, [_c('p', {
    staticClass: "image is-32x32",
    on: {
      "click": function($event) {
        _vm.jumpToUser(_vm.mainPost)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.mainPost.poster.face_url
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h4', {
    class: [_vm.mainPost.poster.gender == 'm' ? 'gender-m' : 'gender-f'],
    on: {
      "click": function($event) {
        _vm.jumpToUser(_vm.mainPost)
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.mainPost.poster.id))]), _vm._v(" "), _c('small', [_c('span', [_vm._v("楼主")]), _vm._v(" " + _vm._s(_vm.mainPost.time) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "media-right"
  }, [_c('span', [(_vm.mainPost && _vm.mainPost.op) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.edit(_vm.mainPost)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-edit"
  })]) : _vm._e()]), _vm._v(" "), _c('span', [_c('a', {
    on: {
      "click": function($event) {
        _vm.reply(_vm.mainPost)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-comments"
  })])]), _vm._v(" "), (_vm.mainPost) ? _c('span', [(!_vm.mainPost.voted) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.voteup(_vm.mainPost, -1)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-good"
  })]) : _c('i', {
    staticClass: "iconfont icon-good voted"
  }), _vm._v("\n              " + _vm._s(_vm.mainPost.voteup_count) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.mainPost) ? _c('span', [(!_vm.mainPost.voteddown) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.votedown(_vm.mainPost, -1)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-bad"
  })]) : _c('i', {
    staticClass: "iconfont icon-bad voted"
  }), _vm._v("\n              " + _vm._s(_vm.mainPost.votedown_count) + "\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "article-body content",
    domProps: {
      "innerHTML": _vm._s(_vm.mainPost.content)
    }
  })]) : (!_vm.mainPost) ? _c('div', {
    staticClass: "oops"
  }, [_c('span', [_vm._v("O0o0Ops...内容不见了")]), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), (_vm.currentPage == 1 && _vm.popularReplies.length) ? _c('div', {
    staticClass: "popular-replies"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.popularReplies), function(article, index) {
    return _c('div', {
      key: index,
      staticClass: "post"
    }, [_c('div', {
      staticClass: "poster media"
    }, [_c('figure', {
      staticClass: "media-left"
    }, [_c('p', {
      staticClass: "image is-32x32",
      on: {
        "click": function($event) {
          _vm.jumpToUser(article)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": article.poster ? article.poster.face_url : ''
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "media-content"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('h4', {
      class: [article.poster ? (article.poster.gender == 'm' ? 'gender-m' : 'gender-f') : 'gender-u'],
      on: {
        "click": function($event) {
          _vm.jumpToUser(article)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(article.poster ? article.poster.id : '已注销'))]), _vm._v(" "), _c('small', [_c('span', [_vm._v(_vm._s(article.pos == 1 ? '沙发' : (article.pos == 2 ? '板凳' : article.pos + '楼')))]), _vm._v("\n                  " + _vm._s(article.time) + "\n                ")])])]), _vm._v(" "), _c('div', {
      staticClass: "media-right"
    }, [_c('span', [(_vm.mainPost && _vm.mainPost.op) ? _c('a', {
      on: {
        "click": function($event) {
          _vm.edit(_vm.mainPost)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-edit"
    })]) : _vm._e()]), _vm._v(" "), _c('span', [_c('a', {
      on: {
        "click": function($event) {
          _vm.reply(_vm.mainPost)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-comments"
    })])]), _vm._v(" "), _c('span', [(!article.voted) ? _c('a', {
      on: {
        "click": function($event) {
          _vm.voteup(article, index)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-good"
    })]) : _c('i', {
      staticClass: "iconfont icon-good voted"
    }), _vm._v("\n                " + _vm._s(article.voteup_count) + "\n              ")]), _vm._v(" "), _c('span', [(!article.voteddown) ? _c('a', {
      on: {
        "click": function($event) {
          _vm.votedown(article, index)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-bad"
    })]) : _c('i', {
      staticClass: "iconfont icon-bad voted"
    }), _vm._v("\n                " + _vm._s(article.votedown_count) + "\n              ")])])]), _vm._v(" "), _c('div', {
      staticClass: "article-body content",
      domProps: {
        "innerHTML": _vm._s(article.content)
      }
    }), _vm._v(" "), (index < _vm.popularReplies.length - 1) ? _c('hr') : _vm._e()])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "posts"
  }, [(_vm.currentPage == 1 && _vm.posts.length) ? _c('div', {
    staticClass: "reply-tag"
  }, [_c('span', {
    staticClass: "tag is-primary"
  }, [_vm._v("全部回复")]), _vm._v(" "), _c('b')]) : _vm._e(), _vm._v(" "), _vm._l((_vm.posts), function(article, index) {
    return _c('div', {
      key: index,
      staticClass: "post",
      attrs: {
        "id": article.pos
      }
    }, [_c('div', {
      staticClass: "poster media"
    }, [_c('figure', {
      staticClass: "media-left"
    }, [_c('p', {
      staticClass: "image is-32x32",
      on: {
        "click": function($event) {
          _vm.jumpToUser(article)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": article.poster ? article.poster.face_url : ''
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "media-content"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('h4', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (article.votedown_count - article.voteup_count < article.votedown_min),
        expression: "article.votedown_count - article.voteup_count < article.votedown_min"
      }],
      class: [article.poster ? (article.poster.gender == 'm' ? 'gender-m' : 'gender-f') : 'gender-u'],
      on: {
        "click": function($event) {
          _vm.jumpToUser(article)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(article.poster ? article.poster.id : '已注销'))]), _vm._v(" "), _c('small', [_c('h4', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (article.votedown_count - article.voteup_count >= article.votedown_min),
        expression: "article.votedown_count - article.voteup_count >= article.votedown_min"
      }],
      class: [article.poster ? (article.poster.gender == 'm' ? 'gender-m' : 'gender-f') : 'gender-u']
    }, [_vm._v("****")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(article.pos == 1 ? '沙发' : article.pos == 2 ? '板凳' : article.pos + '楼'))]), _vm._v("\n                  " + _vm._s(article.time) + "\n                ")])])]), _vm._v(" "), _c('div', {
      staticClass: "media-right"
    }, [_c('span', [(_vm.mainPost && _vm.mainPost.op) ? _c('a', {
      on: {
        "click": function($event) {
          _vm.edit(article)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-edit"
    })]) : _vm._e()]), _vm._v(" "), _c('span', [_c('a', {
      on: {
        "click": function($event) {
          _vm.reply(article)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-comments"
    })])]), _vm._v(" "), _c('span', [(!article.voted) ? _c('a', {
      on: {
        "click": function($event) {
          _vm.voteup(article, index)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-good"
    })]) : _c('i', {
      staticClass: "iconfont icon-good voted"
    }), _vm._v("\n                " + _vm._s(article.voteup_count) + "\n              ")]), _vm._v(" "), _c('span', [(!article.voteddown) ? _c('a', {
      on: {
        "click": function($event) {
          _vm.votedown(article, index)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-bad"
    })]) : _c('i', {
      staticClass: "iconfont icon-bad voted"
    }), _vm._v("\n                " + _vm._s(article.votedown_count) + "\n              ")])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (article.votedown_count - article.voteup_count < article.votedown_min),
        expression: "article.votedown_count - article.voteup_count < article.votedown_min"
      }],
      staticClass: "article-body content",
      class: {
        'selected-content': article.pos == _vm.position, 'remove-selected': _vm.removeSelected
      },
      domProps: {
        "innerHTML": _vm._s(article.content)
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (article.votedown_count - article.voteup_count >= article.votedown_min),
        expression: "article.votedown_count - article.voteup_count >= article.votedown_min"
      }],
      staticClass: "a-background"
    }, [_c('p', [_vm._v("此楼踩的人太多已被折叠。")]), _vm._v(" "), _c('p', [_vm._v("请多多注意自己的发言哦...")]), _vm._v(" "), _c('a', {
      staticClass: "a-func-dispCai button",
      on: {
        "click": function($event) {
          _vm.votedown_view(article.pos)
        }
      }
    }, [_vm._v("手贱想看")])]), _vm._v(" "), _c('hr')])
  })], 2)])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "! isLoading"
    }],
    staticClass: "paginate"
  }, [_c('picker', {
    ref: "pagePicker",
    attrs: {
      "data": _vm.pagePickerData
    },
    on: {
      "change": _vm.pageChanged
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "columns is-mobile paginate-items"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": _vm.hidePagePicker
    }
  }, [_vm._v("取消")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": _vm.getFirstPage
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('span', [_vm._v(_vm._s(_vm.currentPage + '/' + _vm.totalPage))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": _vm.getLastPage
    }
  }, [_vm._v("末页")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": _vm.getSelectedPage
    }
  }, [_vm._v("确认")])])])])])]), _vm._v(" "), (_vm.mainPost) ? [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showVoteChoice),
      expression: "showVoteChoice"
    }],
    staticClass: "card",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('header', {
    staticClass: "columns  is-mobile paginate-items"
  }, [_c('div', {
    staticClass: "column"
  }, [(_vm.mainPost && !_vm.mainPost.voted) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.voteup(_vm.mainPost, -1);
        _vm.showVote();
      }
    }
  }, [_vm._v("赞 " + _vm._s(_vm.mainPost.voteup_count))]) : _c('a', {
    on: {
      "click": function($event) {
        _vm.showVote()
      }
    }
  }, [_vm._v("赞 " + _vm._s(_vm.mainPost.voteup_count))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [(_vm.mainPost && !_vm.mainPost.voteddown) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.votedown(_vm.mainPost, -1);
        _vm.showVote();
      }
    }
  }, [_vm._v("踩 " + _vm._s(_vm.mainPost.votedown_count))]) : _c('a', {
    on: {
      "click": function($event) {
        _vm.showVote()
      }
    }
  }, [_vm._v("踩 " + _vm._s(_vm.mainPost.votedown_count))])])])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "columns is-mobile paginate-items"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": _vm.showVote
    }
  }, [_vm._m(1), _vm._v("\n            赞 " + _vm._s(_vm.mainPost ? _vm.mainPost.voteup_count : '0') + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": _vm.getPrevPage
    }
  }, [_vm._v("上页")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": _vm.showPagePicker
    }
  }, [_vm._v(_vm._s(_vm.currentPage + '/' + _vm.totalPage))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": _vm.getNextPage
    }
  }, [_vm._v("下页")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.reply(_vm.mainPost)
      }
    }
  }, [_vm._v("回复")])])])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reply-tag"
  }, [_c('span', {
    staticClass: "tag is-danger"
  }, [_vm._v("精彩回复")]), _vm._v(" "), _c('b')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "iconfont icon-less up"
  }), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-moreunfold down"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b4bfcb88","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Thread.vue
// module id = 255
// module chunks = 1